import { useState } from "react";
import ReactPlayer from "react-player";
import { Loader } from "../../layout";
const ResponsiveVideoPlayer = ({ link }) => {
    const [isReady, setIsReady] = useState(false);
  
    const handleReady = () => {

    };
  
    return (
      <div className="w-full h-full  rounded-2xl  ">
        {isReady === (false) && <div className="text-center w-full h-full items-center justify-center">
           <Loader />
            </div>}
        <div className="w-full flex h-full rounded-2xl overflow-hidden ">
  
        <ReactPlayer
          src={link}
          controls
          width="100%"
          height="100%"
          onProgress={()=>setIsReady(true)}
        
          style={{ display: isReady ? "block" : "none" }}
        />
        </div>
      
      </div>
    );
  };
  export default ResponsiveVideoPlayer